<template>
  <div id="main-container">
    <v-dialog/>
    <nav-bar/>
    <div class="inner-container">
      <side-bar/>
      <div class="user-list-container">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/main/NavBar'
import SideBar from '@/components/main/SideBar'
export default {
  data () {
    return {
    }
  },
  methods: {

  },
  components: {
    NavBar,
    SideBar,
  },
  mounted () {
  },
  computed: {
  },
  watch: {
  }
}
</script>

<style lang="scss">
</style>
